function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire402f"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire402f"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $19b178a196359530$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"aKZwI":"index.56b6d4dc.js","5VapV":"textile360.456d72ec.png","lMbud":"timups.5634a9bf.png","aaTvn":"pokebon.fd18e090.png","2SUR6":"portfolio.05eb899a.png","hmlxw":"bonus.670f1b03.png","iazhB":"penalty.241f57b1.png"}'));

// Gestion du scroll pour afficher le menu en fixed
const $2a374cfbc24fcf44$export$dee3b55761fc04ef = {
    headerPosition: ()=>{
        const lastScrollCheck = Math.round(window.scrollY);
        const menuFix = document.querySelector(".menu");
        const totop = document.querySelector(".totop");
        lastScrollCheck > 100 ? menuFix.classList.add("menu__fixed") : menuFix.classList.remove("menu__fixed");
        lastScrollCheck > 100 ? totop.style.display = "flex" : totop.style.display = "none";
    }
};


let $d3accb6e69e94dcc$var$language = "";
let $d3accb6e69e94dcc$var$frameworkFront = "";
let $d3accb6e69e94dcc$var$frameworkBack = "";
let $d3accb6e69e94dcc$var$runtime = "";
let $d3accb6e69e94dcc$var$cms = "";
const $d3accb6e69e94dcc$var$skills = [
    $d3accb6e69e94dcc$var$language = [
        "Langages",
        {
            name: "HTML et Accessibilit\xe9",
            level: "90%"
        },
        {
            name: "CSS et SASS",
            level: "80%"
        },
        {
            name: "Javascript",
            level: "80%"
        },
        {
            name: "SQL",
            level: "70%"
        }
    ],
    $d3accb6e69e94dcc$var$frameworkFront = [
        "Framework Front-End",
        {
            name: "React",
            level: "70%"
        }
    ],
    $d3accb6e69e94dcc$var$frameworkBack = [
        "Framework Back-End",
        {
            name: "Express.js",
            level: "70%"
        }
    ],
    $d3accb6e69e94dcc$var$runtime = [
        "Environnement d'ex\xe9cution",
        {
            name: "Node.js",
            level: "70%"
        },
        {
            name: "Bun",
            level: "20%"
        }
    ],
    $d3accb6e69e94dcc$var$cms = [
        "CMS",
        {
            name: "WordPress",
            level: "30%"
        }
    ]
];
const $d3accb6e69e94dcc$var$addSkillToDom = (skill)=>{
    const ul = document.querySelector("#skill-content");
    const li = document.createElement("li");
    li.classList.add("cv__container__content__card");
    const h3 = document.createElement("h3");
    h3.classList.add("cv__container__content__card__poste");
    h3.textContent = skill[0];
    skill.shift(0);
    ul.append(li);
    li.append(h3);
};
const $d3accb6e69e94dcc$var$addContentToSkill = (content)=>{
    const li = document.querySelector("#skill-content li:last-child");
    const h4 = document.createElement("h4");
    h4.classList.add("cv__container__content__card__entreprise");
    h4.textContent = content.name;
    const divBar = document.createElement("div");
    divBar.classList.add("cv__container__content__card__bar");
    const divProgress = document.createElement("div");
    divProgress.classList.add("cv__container__content__card__progress");
    divProgress.style.width = `calc(${content.level} - 4px)`;
    li.append(h4, divBar);
    divBar.append(divProgress);
};
for (const skill of $d3accb6e69e94dcc$var$skills){
    $d3accb6e69e94dcc$var$addSkillToDom(skill);
    for (const content of skill)$d3accb6e69e94dcc$var$addContentToSkill(content);
}
const $d3accb6e69e94dcc$var$jobBtn = document.querySelector("#job");
const $d3accb6e69e94dcc$var$skillBtn = document.querySelector("#skill");
const $d3accb6e69e94dcc$var$trainingBtn = document.querySelector("#training");
const $d3accb6e69e94dcc$var$jobContent = document.querySelector(".cv__container__content:first-child");
const $d3accb6e69e94dcc$var$skillContent = document.querySelector(".cv__container__content:nth-child(even)");
const $d3accb6e69e94dcc$var$trainingContent = document.querySelector(".cv__container__content:last-child");
const $d3accb6e69e94dcc$var$titleChange = document.querySelector("#modif-title");
$d3accb6e69e94dcc$var$jobBtn.addEventListener("click", ()=>{
    $d3accb6e69e94dcc$var$titleChange.textContent = "Mes exp\xe9riences";
    $d3accb6e69e94dcc$var$jobBtn.classList.add("current");
    $d3accb6e69e94dcc$var$skillBtn.classList.remove("current");
    $d3accb6e69e94dcc$var$trainingBtn.classList.remove("current");
    $d3accb6e69e94dcc$var$jobContent.classList.remove("hidden");
    $d3accb6e69e94dcc$var$skillContent.classList.add("hidden");
    $d3accb6e69e94dcc$var$trainingContent.classList.add("hidden");
});
$d3accb6e69e94dcc$var$skillBtn.addEventListener("click", ()=>{
    $d3accb6e69e94dcc$var$titleChange.textContent = "Mes comp\xe9tences";
    $d3accb6e69e94dcc$var$jobBtn.classList.remove("current");
    $d3accb6e69e94dcc$var$skillBtn.classList.add("current");
    $d3accb6e69e94dcc$var$trainingBtn.classList.remove("current");
    $d3accb6e69e94dcc$var$jobContent.classList.add("hidden");
    $d3accb6e69e94dcc$var$skillContent.classList.remove("hidden");
    $d3accb6e69e94dcc$var$trainingContent.classList.add("hidden");
});
$d3accb6e69e94dcc$var$trainingBtn.addEventListener("click", ()=>{
    $d3accb6e69e94dcc$var$titleChange.textContent = "Mes formations";
    $d3accb6e69e94dcc$var$jobBtn.classList.remove("current");
    $d3accb6e69e94dcc$var$skillBtn.classList.remove("current");
    $d3accb6e69e94dcc$var$trainingBtn.classList.add("current");
    $d3accb6e69e94dcc$var$jobContent.classList.add("hidden");
    $d3accb6e69e94dcc$var$skillContent.classList.add("hidden");
    $d3accb6e69e94dcc$var$trainingContent.classList.remove("hidden");
});


const $0433f47a2bddf594$var$jobs = [
    {
        poste: "Stage",
        entreprise: "Tremplin 01",
        years: [
            2024,
            2024
        ],
        months: [
            "mars",
            "avril"
        ],
        description: "R\xe9alisation du site internet (front-end et back-end) textile360.fr / Framework utilis\xe9 NextJs / composant UI React Mantine / ORM Prisma / Mise en production du site sur vercel"
    },
    {
        poste: "Renovation de biens immobiliers",
        entreprise: "A titre personnel",
        years: [
            2017,
            2023
        ],
        months: [
            "ao\xfbt",
            "d\xe9cembre"
        ],
        description: `Renovation complète de 3 biens immobiliers comprenant tout le second oeuvre ainsi qu'une grosse partie du gros oeuvre :
        Second oeuvre : électricité/plomberie et sanitaire/cuisine/menuiserie/carrelage/isolation/placo/peinture/
        Gros oeuvre : dalle sur hérisson/chape flottante sur isolant type xps/embrasure`
    },
    {
        poste: "Adjoint responsable magasin",
        entreprise: "Phone House sarl",
        years: [
            2015,
            2017
        ],
        months: [
            "ao\xfbt",
            "juillet"
        ],
        description: "Achat / Vente / R\xe9paration de mat\xe9riel informatique et smartphones - Gestion des stocks - Merchandising - Gestion des plannings - Supervision de deux techniciens"
    },
    {
        poste: "Responsable rayon informatique",
        entreprise: "Soci\xe9t\xe9 Happy Cash",
        years: [
            2013,
            2014
        ],
        months: [
            "juin",
            "octobre"
        ],
        description: "Gestion du rayon informatique (Conseil client / Vente / Achat / SAV / Suivi des stocks)"
    },
    {
        poste: "Hotliner niveau 2 et formateur",
        entreprise: "Soci\xe9t\xe9 JDL Entreprise",
        years: [
            2011,
            2012
        ],
        months: [
            "d\xe9cembre",
            "juillet"
        ],
        description: "Support utilisateur en informatique et data mobile (iOS / Blackberry / Android / Cl\xe9s 3G) - Formation des clients B2B sur l'utilisation basique des smartphones (Mail / Internet / Messageries)"
    },
    {
        poste: "Vendeur",
        entreprise: "Soci\xe9t\xe9 Game",
        years: [
            2010,
            2011
        ],
        months: [
            "octobre",
            "avril"
        ],
        description: "Gestion de la caisson - Gestion du r\xe9assort - Merchandising - Conseil client"
    },
    {
        poste: "Responsable magasin",
        entreprise: "Soci\xe9t\xe9 Occaziophone",
        years: [
            2010,
            2010
        ],
        months: [
            "avril",
            "juillet"
        ],
        description: "R\xe9paration de smartphones - Gestion des stocks - Merchandising - Gestion de la caisse"
    },
    {
        poste: "Hotliner niveau 1",
        entreprise: "Soci\xe9t\xe9 B2S",
        years: [
            2009,
            2009
        ],
        months: [
            "mars",
            "juillet"
        ],
        description: "D\xe9pannage de box internet et des conflits mat\xe9riels et logiciels BtoC"
    }
];
const $0433f47a2bddf594$var$addJobToDom = (job)=>{
    const ul = document.querySelector("#job-content");
    const li = document.createElement("li");
    li.classList.add("cv__container__content__card");
    const pPoste = document.createElement("p");
    pPoste.classList.add("cv__container__content__card__poste");
    pPoste.textContent = job.poste;
    const pEntreprise = document.createElement("p");
    pEntreprise.classList.add("cv__container__content__card__entreprise");
    pEntreprise.textContent = job.entreprise;
    const spanDate = document.createElement("span");
    spanDate.classList.add("cv__container__content__card__date");
    spanDate.textContent = `de ${job.months[0]}-${job.years[0]} à ${job.months[1]}-${job.years[1]}`;
    const pDescription = document.createElement("p");
    //pDescription.classList.add('');a completer
    pDescription.textContent = job.description;
    li.append(pPoste, pEntreprise, spanDate, pDescription);
    ul.append(li);
};
for (const job of $0433f47a2bddf594$var$jobs)$0433f47a2bddf594$var$addJobToDom(job);


const $bcdf11c67fd0a615$var$trainings = [
    {
        name: "TP D\xe9veloppeur web et web mobile (option accessibilit\xe9)",
        school: "O'Clock (75008) - Adea (01000)",
        years: "de 2023 \xe0 2024",
        statut: "Obtenu"
    },
    {
        name: "Formation Hotliner niveau 1",
        school: "Orange / France T\xe9l\xe9com (13290)",
        years: "2009",
        statut: "certifi\xe9"
    },
    {
        name: "Bac Pro Syst\xe8me Electronique Num\xe9rique",
        school: "Lyc\xe9e Saint Joseph (01000)",
        years: "2008",
        statut: "Niveau - dipl\xf4me non pass\xe9"
    },
    {
        name: "Bep Electronique",
        school: "Lyc\xe9e Alexandre B\xe9rard (01500)",
        years: "de 2007 \xe0 2008",
        statut: "Obtenu"
    }
];
const $bcdf11c67fd0a615$var$addTrainingToDom = (training)=>{
    const ul = document.querySelector("#training-content");
    const li = document.createElement("li");
    li.classList.add("cv__container__content__card");
    const spanName = document.createElement("span");
    spanName.classList.add("cv__container__content__card__poste");
    spanName.textContent = training.name;
    const spanSchool = document.createElement("span");
    spanSchool.classList.add("cv__container__content__card__entreprise");
    spanSchool.textContent = training.school;
    const spanYear = document.createElement("span");
    // spanYear.classList.add('');
    spanYear.textContent = training.years;
    const spanStatut = document.createElement("span");
    spanStatut.classList.add("cv__container__content__card__entreprise");
    spanStatut.textContent = training.statut;
    li.append(spanName, spanSchool, spanYear, spanStatut);
    ul.append(li);
};
for (const training of $bcdf11c67fd0a615$var$trainings)$bcdf11c67fd0a615$var$addTrainingToDom(training);


//gestion des cards de portfolio
var $d3fdf454359d958d$exports = {};

$d3fdf454359d958d$exports = new URL((parcelRequire("27Lyk")).resolve("5VapV"), import.meta.url).toString();


var $34fca57814a3edee$exports = {};

$34fca57814a3edee$exports = new URL((parcelRequire("27Lyk")).resolve("lMbud"), import.meta.url).toString();


var $de6fd55244856be0$exports = {};

$de6fd55244856be0$exports = new URL((parcelRequire("27Lyk")).resolve("aaTvn"), import.meta.url).toString();


var $26ff543920abc85d$exports = {};

$26ff543920abc85d$exports = new URL((parcelRequire("27Lyk")).resolve("2SUR6"), import.meta.url).toString();


var $f740b818a9b6b890$exports = {};

$f740b818a9b6b890$exports = new URL((parcelRequire("27Lyk")).resolve("hmlxw"), import.meta.url).toString();


var $c2fa7b85e0e57387$exports = {};

$c2fa7b85e0e57387$exports = new URL((parcelRequire("27Lyk")).resolve("iazhB"), import.meta.url).toString();


const $89d75396b2068268$var$portfolios = [
    {
        language: "js",
        title: "Textile360",
        desc: "Projet de stage",
        url: new URL("https://textile360.fr"),
        thumbImg: new URL($d3fdf454359d958d$exports)
    },
    {
        language: "css",
        title: "TimUps",
        desc: "Exercice personnel en html/css",
        url: new URL("https://timups-one.vercel.app"),
        thumbImg: new URL($34fca57814a3edee$exports)
    },
    {
        language: "css",
        title: "PokeBon",
        desc: "Atelier de formation html/css",
        url: new URL("https://s02-e10-exos-pokebon-frag-rappy.vercel.app"),
        thumbImg: new URL($de6fd55244856be0$exports)
    },
    {
        language: "js",
        title: "Portfolio",
        desc: "Exercice personnel en html/css/js",
        url: new URL("https://fragrappy-portfolio.vercel.app"),
        thumbImg: new URL($26ff543920abc85d$exports)
    },
    {
        language: "css",
        title: "Blog",
        desc: "Atelier de formation",
        url: new URL("https://s02-atelier-revision-bonus-frag-rappy.vercel.app"),
        thumbImg: new URL($f740b818a9b6b890$exports)
    },
    {
        language: "js",
        title: "Penalty Game",
        desc: "Exercice personnel en html/css/js",
        url: new URL("https://penalty-game-one.vercel.app"),
        thumbImg: new URL($c2fa7b85e0e57387$exports)
    }
];
function $89d75396b2068268$var$addCardToDom(portfolio) {
    const card = document.querySelector(".portfolio__container");
    const article = document.createElement("article");
    article.classList.add("portfolio__container__card");
    if (portfolio.language == "css") article.setAttribute("data-language", "css");
    else article.setAttribute("data-language", "js");
    const div = document.createElement("div");
    div.classList.add("portfolio__container__card__img");
    const aImg = document.createElement("a");
    aImg.setAttribute("href", portfolio.url);
    aImg.setAttribute("target", "_blank");
    aImg.setAttribute("rel", "noopener");
    const img = document.createElement("img");
    img.setAttribute("src", portfolio.thumbImg);
    const aTitle = document.createElement("a");
    aTitle.setAttribute("href", portfolio.url);
    aTitle.setAttribute("target", "_blank");
    aTitle.setAttribute("rel", "noopener");
    const h2 = document.createElement("h2");
    h2.textContent = portfolio.title;
    const p = document.createElement("p");
    p.textContent = portfolio.desc;
    card.append(article);
    article.append(div, h2, aTitle, p);
    div.append(aImg);
    aImg.append(img);
    aTitle.append(h2);
}
// Cela insert un objet du tableau portfolios dans le dom avec addCardToDom
for (const portfolio of $89d75396b2068268$var$portfolios)$89d75396b2068268$var$addCardToDom(portfolio);
//fonction de filtre pas fofolle
const $89d75396b2068268$var$filter = {
    cards: document.querySelectorAll(`.portfolio__container__card`),
    allFolio: document.querySelector("#all-folio"),
    cssFolio: document.querySelector("#css-folio"),
    jsFolio: document.querySelector("#js-folio"),
    cardFilter: (lang)=>{
        for (const card of $89d75396b2068268$var$filter.cards)if (card.dataset.language != lang) card.classList.add("hidden");
        else card.classList.remove("hidden");
    }
};
//ecouteur pour les differents boutons de filtre des cards
$89d75396b2068268$var$filter.allFolio.addEventListener("click", ()=>{
    $89d75396b2068268$var$filter.allFolio.classList.add("current");
    $89d75396b2068268$var$filter.cssFolio.classList.remove("current");
    $89d75396b2068268$var$filter.jsFolio.classList.remove("current");
    for (const card of $89d75396b2068268$var$filter.cards)card.classList.remove("hidden");
});
$89d75396b2068268$var$filter.cssFolio.addEventListener("click", ()=>{
    $89d75396b2068268$var$filter.allFolio.classList.remove("current");
    $89d75396b2068268$var$filter.cssFolio.classList.add("current");
    $89d75396b2068268$var$filter.jsFolio.classList.remove("current");
    $89d75396b2068268$var$filter.cardFilter("css");
});
$89d75396b2068268$var$filter.jsFolio.addEventListener("click", ()=>{
    $89d75396b2068268$var$filter.allFolio.classList.remove("current");
    $89d75396b2068268$var$filter.cssFolio.classList.remove("current");
    $89d75396b2068268$var$filter.jsFolio.classList.add("current");
    $89d75396b2068268$var$filter.cardFilter("js");
});


window.addEventListener("scroll", (0, $2a374cfbc24fcf44$export$dee3b55761fc04ef).headerPosition);
//gestion en temps réel des menus et boutons en mode mobile et tablet/desktop
window.addEventListener("DOMContentLoaded", ()=>{
    const menu = document.querySelector(".menu__nav");
    const menuToogle = document.querySelector(".menu__toogle");
    const totop = document.querySelector(".totop");
    const panel = document.querySelector(".panel");
    const panelPop = document.querySelector(".panel__pop");
    //gestion du clic pour le menu burger
    const displayNavMobile = ()=>{
        if (menu.style.display == "none") {
            menu.style.display = "";
            menu.classList.add("menu__nav__on");
        } else {
            menu.style.display = "none";
            menu.classList.remove("menu__nav__on");
        }
    };
    menuToogle.addEventListener("click", displayNavMobile);
    //gestion du clic sur le panel en cours de construction
    panel.addEventListener("click", ()=>{
        panelPop.classList.toggle("hidden");
    });
    //gestion du clic sur le bouton retourner en haut
    totop.addEventListener("click", ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
    //gestion de la largeur au chargement de la page
    window.onload = ()=>{
        const width = window.innerWidth;
        if (width > 899) {
            menu.style.display = "";
            menuToogle.style.display = "none";
        } else {
            menu.style.display = "none";
            menuToogle.style.display = "";
        }
    };
    //gestion de la largeur au changement de taille de la fenêtre
    window.onresize = ()=>{
        const width = window.innerWidth;
        if (width > 899) {
            menu.style.display = "";
            menu.classList.remove("menu__nav__on");
            menuToogle.style.display = "none";
        } else {
            menu.style.display = "none";
            menuToogle.style.display = "";
        }
    };
});


//# sourceMappingURL=index.56b6d4dc.js.map
